import contract from '@mailobj-browser/front/js/contracts/contract.js'
import array from '@mailobj-browser/front/js/utils/array.js'
import destination from './destination.js'
import dropZone from './dropZone.js'
import form from './form.js'
import open from './open.js'
import origin from './origin.js'
import paired from './paired.js'
import remove from './remove/remove.js'
import uploader from './uploader.js'

export default contract({
  destination: array([
    destination
  ]),
  dropZone: array([
    dropZone
  ]),
  form: array([
    form
  ]),
  open: array([
    open
  ]),
  origin: array([
    origin
  ]),
  paired: array([
    paired
  ]),
  remove,
  uploader: array([
    uploader
  ])
})
